module.exports = __webpack_public_path__ + "static/img/copywriting_masterclass_1200x628-01.d18a3bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/copywriting_masterclass_1200x628-01.png
// module id = GC1z
// module chunks = 1